import React, { PropsWithChildren } from "react";

import { Box, DarkTooltip } from "../../../common/components";
import { createStyles, palette } from "../../../styles/theme";
import { Image, PropsWithDataTest } from "../../../types";
import {
  getConditionnalStyle,
  useThemeBreakpoints,
} from "../../../utils/themeUtils";

const styles = createStyles({
  container: {
    borderRadius: "8px",
    border: `1px solid ${palette.grey.midGrey}`,
    width: "52px",
    height: "46px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "2px",
    cursor: "pointer",
    background: "white",
  },
  active: {
    border: `2px solid ${palette.blue.secondary}`,
  },
});

interface Props extends PropsWithDataTest<PropsWithChildren> {
  active?: boolean;
  designImages?: Image[];
  designErrorKey?: string;
  tooltip?: string;
  onClick?: () => void;
}

const DesignPill = ({
  active = false,
  children,
  designImages,
  designErrorKey,
  tooltip = "",
  onClick,
  "data-test": dataTest,
}: Props) => {
  const { isMobile } = useThemeBreakpoints();
  return (
    <DarkTooltip title={tooltip} followCursor={!isMobile}>
      <Box
        onClick={onClick}
        sx={[styles.container, getConditionnalStyle(active, styles.active)]}
        data-test={dataTest}
      >
        {designImages && !designErrorKey ? (
          <React.Fragment>
            {designImages?.map((image) => (
              <img
                src={image.url}
                alt={image.side}
                style={{
                  height: "26px",
                  flexShrink: "0",
                  maxWidth: `calc(52px / ${designImages.length} - 2px - 2px)`,
                }}
                key={image.side}
              />
            ))}
          </React.Fragment>
        ) : (
          <React.Fragment>{children}</React.Fragment>
        )}
      </Box>
    </DarkTooltip>
  );
};

export default DesignPill;
